import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-event-calendar',
  templateUrl: './event-calendar.component.html',
  styleUrls: ['./event-calendar.component.scss']
})
export class EventCalendarComponent {
  currentDate = moment(); // Use moment instead of new Date()
  selectedDate = this.currentDate.date();
  currentWeek: moment.Moment[] = [];

  ngOnInit() {
    this.generateWeek();
  }

  generateWeek() {
    const startOfWeek = this.currentDate.clone().startOf('week').add(1, 'days'); // Move to Monday

    this.currentWeek = [];
    for (let i = 0; i < 7; i++) {
      this.currentWeek.push(startOfWeek.clone().add(i, 'days'));
    }
  }

  prevWeek() {
    this.currentDate = this.currentDate.clone().subtract(7, 'days');
    this.generateWeek();
  }

  nextWeek() {
    this.currentDate = this.currentDate.clone().add(7, 'days');
    this.generateWeek();
  }

  selectDate(date: number) {
    this.selectedDate = date;
  }


}
